import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.PANEL.BANNER

export function addBannerPanel(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editBannerPanel(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteBannerPanel(panelId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { panelId } })
}

export function getBannerPanelList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
